<form (ngSubmit)="submit()" [formGroup]="magazineForm" action="" class="form">
  <div class="form__left">
    <app-button [enabled]="magazineForm.valid" text="Atualizar" type="submit"></app-button>
    <app-input [control]="magazineForm.get('title')" label="Título"></app-input>
    <app-input [control]="magazineForm.get('slug')" label="Slug"></app-input>

  </div>

  <div class="form__right">
    <app-image-upload
      (deleteEvent)="deleteImage()"
      (uploadEvent)="uploadImage($event)"
      [image]="magazine.image"
    ></app-image-upload>

  </div>

</form>
<div class="form__content-title">Conteúdo</div>
<app-editorjs [data]="magazine.description"></app-editorjs>
